var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lottery3d-mid"},[_c('DisplayMainResults',{attrs:{"ass_a":_vm.ass_a,"ass_b":_vm.ass_b,"ass_c":_vm.ass_c,"ass_d":_vm.ass_d,"ass_e":_vm.ass_e}}),_c('LotteryBetting')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }